export default __webpack_public_path__ + "static/media/airdockz-wht-1.377e7130.png";